// extracted by mini-css-extract-plugin
module.exports = {"lia-header":"TagsHeaderWidget_lia-header__NPDrA","lia-title":"TagsHeaderWidget_lia-title__4WUwY","lia-topics-count":"TagsHeaderWidget_lia-topics-count__USEHE"};